import { Link, useLocation } from "wouter";
import { ErpShell } from "../layout/ErpShell.js";
import { useT } from "../../i18n/index.js";
import { FILTER_PANEL_STYLE } from "../common/FilterBar.js";

export function BankShell({
  subtitle,
  toolbar,
  children,
}: {
  subtitle: string;
  toolbar?: React.ReactNode;
  children: React.ReactNode;
}) {
  const [location] = useLocation();
  const t = useT();
  const NAV: ReadonlyArray<{ href: string; label: string }> = [
    { href: "/banco", label: t("bankShell.navStatements") },
    { href: "/banco/importar", label: t("bankShell.navImport") },
    { href: "/banco/categorias", label: t("bankShell.navCategories") },
    { href: "/banco/reconciliacao", label: t("bankShell.navReconciliation") },
    { href: "/banco/socio", label: t("bankShell.navPartner") },
  ];
  return (
    <ErpShell active="banco">
      {/* Sub-navegação do módulo banco (tabs dentro da seção Banque) */}
      <div className="mb-5">
        <p className="text-xs uppercase tracking-wider text-neutral-500 mb-2">
          {t("bankShell.moduleLabel")} — {subtitle}
        </p>
        <nav className="flex flex-wrap gap-1">
          {NAV.map((n) => {
            const active =
              n.href === "/banco" ? location === "/banco" : location.startsWith(n.href);
            return (
              <Link
                key={n.href}
                href={n.href}
                className={
                  active
                    ? "rounded-md bg-lime/15 border border-lime/40 text-lime px-3 py-1 text-xs"
                    : "rounded-md border border-neutral-800 hover:border-lime hover:text-lime px-3 py-1 text-xs text-neutral-400"
                }
              >
                {n.label}
              </Link>
            );
          })}
        </nav>
      </div>
      {/* CEO 2026-10-31 — mesma moldura dos painéis de filtro das listas. */}
      {toolbar && (
        <div
          className="mb-5 rounded-xl border p-4"
          style={FILTER_PANEL_STYLE}
          data-testid="bank-filter-panel"
        >
          {toolbar}
        </div>
      )}
      <div className="space-y-6">{children}</div>
    </ErpShell>
  );
}

export const bankInputClass =
  "rounded-md border border-neutral-800 bg-neutral-900 px-3 py-1.5 text-sm focus:border-lime outline-none disabled:opacity-50";

export function BankCard({
  title,
  subtitle,
  action,
  children,
  padded = true,
}: {
  title?: string;
  subtitle?: string;
  action?: React.ReactNode;
  children?: React.ReactNode;
  padded?: boolean;
}) {
  return (
    <section className="rounded-lg border border-neutral-800 bg-neutral-900 overflow-hidden">
      {(title || action) && (
        <div className="px-5 py-3 border-b border-neutral-800 flex items-center justify-between">
          <div>
            {title && (
              <h2 className="text-sm font-semibold uppercase tracking-wider text-neutral-300">
                {title}
              </h2>
            )}
            {subtitle && <p className="text-xs text-neutral-500 mt-0.5">{subtitle}</p>}
          </div>
          {action && <div>{action}</div>}
        </div>
      )}
      {children !== undefined && <div className={padded ? "p-5" : ""}>{children}</div>}
    </section>
  );
}
